import React from "react";
import { SectionCard } from "../scraper";

const RANK_COLORS = [
    "bg-amber-400",
    "bg-gray-400",
    "bg-orange-300",
    "bg-gray-200",
    "bg-gray-200",
];

const AnalyticsListCard = ({
    title,
    items = [],
    labelKey,
    valueKey,
}) => {
    const max = items.length
        ? Math.max(...items.map((i) => i[valueKey] || 0))
        : 1;

    return (
        <SectionCard title={title} className="h-full">
            {items.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-10 text-gray-300">
                    <svg className="w-8 h-8 mb-2" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.5V19a1 1 0 001 1h16a1 1 0 001-1v-5.5M3 13.5l9-9 9 9M3 13.5h18" />
                    </svg>
                    <span className="text-sm text-gray-400">No data available</span>
                </div>
            ) : (
                <div className="space-y-3">
                    {items.map((item, index) => {
                        const pct = max > 0 ? ((item[valueKey] || 0) / max) * 100 : 0;
                        return (
                            <div key={index} className="group">
                                <div className="flex items-center justify-between mb-1">
                                    <div className="flex items-center gap-2 min-w-0">
                                        {/* Rank badge */}
                                        <span
                                            className={`
                                                flex-shrink-0 w-5 h-5 rounded-full text-[10px] font-bold
                                                flex items-center justify-center text-white
                                                ${RANK_COLORS[index] || "bg-gray-200"}
                                            `}
                                        >
                                            {index + 1}
                                        </span>
                                        <span className="text-sm font-medium text-gray-800 truncate">
                                            {item[labelKey] || "—"}
                                        </span>
                                    </div>
                                    <span className="flex-shrink-0 text-xs font-semibold text-blue-600 bg-blue-50 rounded-full px-2.5 py-0.5 ml-2">
                                        {item[valueKey]}
                                    </span>
                                </div>
                                {/* Progress bar */}
                                <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                                    <div
                                        className="h-full bg-blue-400 rounded-full transition-all"
                                        style={{ width: `${pct}%` }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </SectionCard>
    );
};

export default AnalyticsListCard;